import type { ArdoqId } from '@ardoq/api-types';
import type { Maybe } from '@ardoq/common-helpers';
import type { HtmlSlideCapture } from './slideCaptureSurface$';

type ReportSlideCaptureSources = {
  readerSlideId: Maybe<ArdoqId>;
  searchResultsSlideId: ArdoqId | null;
  hasReportError: boolean;
  hasError: boolean;
  isBusy: boolean;
};

export const toReportSlideCapture = ({
  readerSlideId,
  searchResultsSlideId,
  hasReportError,
  hasError,
  isBusy,
}: ReportSlideCaptureSources): HtmlSlideCapture => ({
  slideId: hasReportError ? (readerSlideId ?? null) : searchResultsSlideId,
  isBusy,
  hasError,
  isReport: true,
});
